module.exports = __webpack_public_path__ + "img/ffcLogo.f1e83d2f.png";